import type { NavMainItem, NavSection } from "./nav-types";
import { settingsSideBarData } from "./settings-nav-data";

export const isNavItemActive = (pathname: string, url: string) => {
  if (url === "/settings") {
    return pathname === "/settings";
  }

  return pathname === url || pathname.startsWith(`${url}/`);
};

export const findActiveNavItem = (
  pathname: string,
  items: NavMainItem[],
): NavMainItem | undefined => {
  let bestMatch: NavMainItem | undefined;

  for (const item of items) {
    if (
      isNavItemActive(pathname, item.url) &&
      (!bestMatch || item.url.length > bestMatch.url.length)
    ) {
      bestMatch = item;
    }

    for (const subItem of item.items ?? []) {
      if (
        isNavItemActive(pathname, subItem.url) &&
        (!bestMatch || subItem.url.length > bestMatch.url.length)
      ) {
        bestMatch = subItem;
      }
    }
  }

  return bestMatch;
};

export const findActiveNavMatch = (
  pathname: string,
  sections: NavSection[],
  flatItems: NavMainItem[] = settingsSideBarData,
) => {
  const sectionItems = sections.flatMap((section) => section.items);
  return findActiveNavItem(pathname, [...flatItems, ...sectionItems]);
};

export const getNavItemByUrl = (
  url: string | undefined,
  sections: NavSection[],
  flatItems: NavMainItem[] = settingsSideBarData,
): NavMainItem | undefined => {
  if (!url) {
    return undefined;
  }

  const allItems = [...flatItems, ...sections.flatMap((section) => section.items)];

  for (const item of allItems) {
    if (item.url === url) {
      return item;
    }

    const nestedItem = item.items?.find((subItem) => subItem.url === url);
    if (nestedItem) {
      return nestedItem;
    }
  }

  return undefined;
};
